import types from "./purchaseOrderChangeLogTypes";

export default (state, action) => {
	switch (action.type) {
		case types.SET_LOADING:
			return {
				...state,
				loading: !state.loading
			};
		case types.CREATE_PURCHASE_ORDER_CHANGE_LOG:
			return {
				...state,
				loading: false,
			};
		default:
			return state;
	}
};
